import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { shareOfSearchKpiEndDate, shareOfSearchKpiEvolutionCurrentPeriod } from "../@signals"


export const rangeDatesShareOfSearchKPI = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, shareOfSearchKpiEndDate.value), getPreviousDate({ days: 1 }, shareOfSearchKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 6 }, shareOfSearchKpiEndDate.value), stringToDate(shareOfSearchKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 29 }, shareOfSearchKpiEndDate.value), stringToDate(shareOfSearchKpiEndDate.value)] },
        placement: 'left',
        onFocus: () => shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(shareOfSearchKpiEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(shareOfSearchKpiEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => shareOfSearchKpiEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]